import React, {Component} from 'react';
import history from '../../history';
import {Link} from 'react-router-dom';

function NavItemBody({ item, active }) {
	const { label, details, icon, value, title, badgeVariant } = item;
	return (
		<>
			{icon && <i className={`${icon} p-2 text-primary`} style={{ fontSize: '0.9rem' }} />}
			<span>
				<span className={active ? 'text-primary' : 'color-accent'}>{label}</span>
				{details && (
					<span className="small text-muted" style={{ display: 'table' }}>{details}</span>
				)}
			</span>
			{value != null && value !== '' && (
				badgeVariant ? (
					<span className={`badge badge-${badgeVariant} badge-pill ml-auto`} style={{ minWidth: '1.25rem' }}>{value}</span>
				) : (
					<span className="text-bold ml-auto">{value}</span>
				)
			)}
		</>
	);
}

function renderChild(child, onItemSelect) {
	if (child.children && child.children.length > 0) {
		const visibleChildren = child.children.filter((sub) => sub.show !== false);
		if (!visibleChildren.length) return null;

		return (
			<div key={child.label || child.name} className="side-nav-subgroup">
				<div className="side-nav-subgroup-label text-muted small px-2 py-1">
					{child.label}
				</div>
				{visibleChildren.map((sub) => {
					const className = `item d-flex align-items-center side-nav-group-item side-nav-subgroup-item ${sub.active ? 'active' : ''}`;
					if (sub.link) {
						return (
							<Link
								key={sub.name}
								to={sub.link}
								className={className}
								title={sub.title || undefined}
								onClick={() => onItemSelect(sub.name)}
							>
								<NavItemBody item={sub} active={sub.active} />
							</Link>
						);
					}
					return (
						<div
							className={className}
							key={sub.name}
							onClick={() => onItemSelect(sub.name)}
							title={sub.title || undefined}
							role="button"
							tabIndex={0}
							onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onItemSelect(sub.name); }}
						>
							<NavItemBody item={sub} active={sub.active} />
						</div>
					);
				})}
			</div>
		);
	}
	const className = `item d-flex align-items-center side-nav-group-item ${child.active ? 'active' : ''}`;
	if (child.link) {
		return (
			<Link
				key={child.name}
				to={child.link}
				className={className}
				onClick={() => onItemSelect(child.name)}
			>
				<NavItemBody item={child} active={child.active} />
			</Link>
		);
	}
	return (
		<div
			className={className}
			key={child.name}
			onClick={() => onItemSelect(child.name)}
			role="button"
			tabIndex={0}
			onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onItemSelect(child.name); }}
		>
			<NavItemBody item={child} active={child.active} />
		</div>
	);
}

const SideBar = (props) => {
	const { items, onItemSelect } = props;
	return (
		<div className="side-nav top-nav">
			{items.map((item) => {
				const { label, name, details, icon, value, link, active, children, title, badgeVariant } = item;
				if (children && children.length > 0) {
					return (
						<div key={name || label} className="side-nav-group">
							<div className="side-nav-group-label text-muted small font-weight-600 px-2 py-1">
								{label}
							</div>
							{children.map((child) => renderChild(child, onItemSelect))}
						</div>
					);
				}
				const className = `item d-flex align-items-center ${active ? 'active' : ''}`;
				if (link) {
					return (
						<Link
							key={name || label}
							to={link}
							className={className}
							title={title}
							onClick={() => onItemSelect(name)}
						>
							<i className={`${icon} p-2 text-primary`} />
							<span>
								<span className={active ? 'text-primary' : 'color-accent'}>{label}</span>
								{details && (
									<span className="small text-muted" style={{ display: 'table' }}>{details}</span>
								)}
							</span>
							{value != null && value !== '' && (
								badgeVariant ? (
									<span className={`badge badge-${badgeVariant} badge-pill ml-auto`} style={{ minWidth: '1.25rem' }}>{value}</span>
								) : (
									<span className="text-bold ml-auto">{value}</span>
								)
							)}
						</Link>
					);
				}
				return (
					<div className={className} key={name} onClick={() => onItemSelect(name)} title={title} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onItemSelect(name); }}>
						<i className={`${icon} p-2 text-primary`} />
						<span>
							<span className={active ? 'text-primary' : 'color-accent'}>{label}</span>
							<span className="small text-muted" style={{ display: 'table' }}>{details}</span>
						</span>
						{value != null && value !== '' && (
							badgeVariant ? (
								<span className={`badge badge-${badgeVariant} badge-pill ml-auto`} style={{ minWidth: '1.25rem' }}>{value}</span>
							) : (
								<span className="text-bold ml-auto">{value}</span>
							)
						)}
					</div>
				);
			})}
		</div>
	);
};

export default SideBar;
